import { render, staticRenderFns } from "./media_list.vue?vue&type=template&id=589f8d68&scoped=true&"
import script from "./media_list.vue?vue&type=script&lang=js&"
export * from "./media_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f8d68",
  null
  
)

export default component.exports